import React from 'react';
import { useTheme } from 'styled-components';
import { IPlanHybridDiscount, IPlanProductDiscount } from '../../../logic/Models/Responses/CompetitiveAllowanceResponse';
import { RoundAcres } from '../../../logic/Utility/CalculationUtilities';

export function ProductLevelDiscountRow(props: {
	perBagDiscount: number; 
	product: IPlanProductDiscount;  
}): JSX.Element 
{
	const { perBagDiscount, product } = props;
	const theme = useTheme();

	return <div
		style={{
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			margin: 0,
			marginTop: -1,
			paddingRight: 15,
			paddingLeft: 15,
			paddingTop: 5,
			paddingBottom: 7,
			borderStyle: 'solid',
			borderRadius: 4,
			borderWidth: 1,
			borderColor: theme.colors.lightGrey,
			width: '100%',
			fontWeight: theme.fontWeights.normal,
			fontSize: theme.fontSizes.small,
			textAlign: 'right',
			color: theme.colors.darkGrey
		}}>

		<div style={{ display: 'flex', flexDirection: 'column', width: '20%', textAlign: 'left' }}>
			{product.TreatmentName}
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '5%' }}>
			<div>{RoundAcres(product.Acres)}</div>
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '10%' }}>
			<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(product.PricePerBag)}</div>
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '5%' }}>
			<div>{product.Quantity}</div>
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '10%' }}>
			<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(product.PricePerBag * product.Quantity)}</div>
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '15%' }} />
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				width: '25%',
				alignItems: 'flex-end'
			}} />
		<div style={{ display: 'flex', flexDirection: 'column', width: '12%' }}>
			<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(perBagDiscount * product.Quantity)}</div>
		</div>
		<div style={{ display: 'flex', flexDirection: 'column', width: '10%' }}>
			<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((product.PricePerBag * product.Quantity) - (perBagDiscount * product.Quantity))}</div>
		</div>
	</div>;
}
